import { render, staticRenderFns } from "./scoreOrder.vue?vue&type=template&id=1921eecc&scoped=true"
import script from "./scoreOrder.vue?vue&type=script&lang=js"
export * from "./scoreOrder.vue?vue&type=script&lang=js"
import style0 from "./scoreOrder.vue?vue&type=style&index=0&id=1921eecc&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1921eecc",
  null
  
)

component.options.__file = "scoreOrder.vue"
export default component.exports